import { render, staticRenderFns } from "./FormatsDialog.vue?vue&type=template&id=54daa636&"
import script from "./FormatsDialog.vue?vue&type=script&lang=js&"
export * from "./FormatsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports